// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f0ff9976","389":"2bcc5713","453":"003eb02b","732":"9459e10a","977":"50b53483"}[chunkId] + ".chunk.js";
};